<template>
  <div>
    <div class="card softblue">
      <div class="card-body">
        <div class="media">
          <img :src="userInfo.picture_path ? userInfo.picture_path : '/static/img/user@3x.png'" class="avatar" />
          <div class="media-body">
            <span class="badge rose">학생</span>
            <h5>{{userInfo.name}}</h5>
            <span>{{userInfo.school_name}} {{userInfo.id}}</span>
          </div>
        </div>
      </div>
    </div>

    <el-form :model="frm" :rules="rules" status-icon ref="frm" label-width="140px" class="demo-form" label-position="top">
      <div class="card-body gray">
        <h5>프로필</h5>
        <hr />
        <div class="card-form avatar">
          <div class="uploader">
            <el-upload class="avatar-uploader" action="/api/file/upload" ref="uploader"
              :headers="fileHeaders"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="frm.picture_path" :src="frm.picture_path" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div class="avatar-button">
            <el-button @click="selectFile">수정</el-button>
            <el-button type="danger" @click="deleteUserAvatar">삭제</el-button>
          </div>
        </div>
        <div class="card-form">
          <el-form-item label="이름" prop="name">
            <el-input v-model.trim="frm.name" placeholder="이름" :maxlength="20"></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="card-body gray">
        <h5>알림톡</h5>
        <hr />
        <div class="card-form my-page">
          <el-form-item label="전화번호" prop="phone">
            <el-input type="tel" :disabled="!isPhoneModify" v-model.trim="frm.phone" placeholder="'-' 를 빼고 입력해주세요" @change="autoHypenPhone('phone')" maxlength="13" class="el-input-phone"></el-input>
            <el-button v-if="!isPhoneModify" @click="isPhoneModify = true">수정</el-button>
            <el-button type="primary" v-if="isPhoneModify" @click="requestCallback">인증요청</el-button>
          </el-form-item>
          <el-form-item label="인증번호" v-if="!isDisabled">
            <el-input v-model.trim="pincode" :disabled="isDisabled" type="tel" maxlength="6" placeholder="인증번호(6자리)" class="el-input-pincode"></el-input>
            <el-button type="danger" :disabled="isDisabled || pincode.length !== 6" @click="confirmCallback">인증 확인</el-button>
            <el-button type="primary" :disabled="phoneDisabled" @click="requestCallback">재요청</el-button>
            <br />
            <countdown ref="countdown" v-if="!isDisabled" :time="timer" :auto-start="false">
              <template slot-scope="props">남은 시간 {{`${props.minutes} : ${props.seconds}`}}</template>
            </countdown>
          </el-form-item>
          <el-form-item label="알림톡 수신 설정" prop="msg_type">
            <el-radio-group v-model="frm.msg_type" class="stone-radio-btton">
              <el-radio-button label="K">카카오톡</el-radio-button>
              <el-radio-button label="S">SMS</el-radio-button>
              <el-radio-button label="N">수신거부</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </div>
      </div>
      <div class="card-body gray">
        <h5>비밀번호</h5>
        <hr />
        <div class="card-form">
          <el-form-item label="현재 비밀번호" prop="password">
            <el-input type="password" v-model="frm.password" :maxlength="16"></el-input>
          </el-form-item>
          <el-form-item label="새로운 비밀번호" prop="password_new">
            <el-input type="password" v-model="frm.password_new" :maxlength="16"></el-input>
          </el-form-item>
          <el-form-item label="새로운 비밀번호 확인" prop="password_confirm">
            <el-input type="password" v-model="frm.password_confirm" :maxlength="16"></el-input>
          </el-form-item>
        </div>
      </div>
    </el-form>

    <div class="mypage-button">
      <button type="button" class="btn mint" @click="submitForm">저장</button>
      <button type="button" class="btn gray" @click="cancleForm">취소</button>
    </div>
  </div>

</template>

<script>

import common from '@/modules/common'
import VueCountdown from '@xkeshi/vue-countdown'

export default {
  name: 'S990101',
  mixins: [common.mixins],
  components: {countdown: VueCountdown},
  data () {
    const validatePass1 = (rule, value, callback) => {
      if (value === '' && this.frm.password_new !== '') {
        callback(new Error('현재비밀번호를 입력하십시오.'))
      } else {
        callback()
      }
    }
    const validatePass2 = (rule, value, callback) => {
      // const passwordPattern = /^(?=.*\d)(?=.*[#$@!%&*?])(?=.*[A-Z])(?=.*[a-z])[A-Za-z\d#$@!%&*?]{8,}$/
      const passwordPattern = /^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z\d#$@!%&*?]{8,16}$/
      if (this.frm.password !== '') {
        if (!passwordPattern.test(value)) {
          callback(new Error('8~16자리의 영문, 숫자 조합으로 사용가능합니다.'))
        } else if (this.frm.password_confirm !== '') {
          this.$refs.frm.validateField('password_confirm')
        }
      }
      callback()
    }
    const validatePass3 = (rule, value, callback) => {
      if (value !== this.frm.password_new) {
        callback(new Error('새로운 비밀번호와 다릅니다. 비밀번호를 확인하십시오.'))
      } else {
        callback()
      }
    }
    return {
      viewMode: false,
      noticeData: [],
      noticeColumns: [
        {label: '작성일', prop: 'reg_dt', align: 'center'},
        {label: '제목', prop: 'title', align: 'left'}
      ],
      noticeProps: {},
      userInfo: {
        picture_path: '',
        name: '',
        id: '',
        school_name: '',
        msg_type: '',
        phone: ''
      },
      frm: {
        user_info_seq: 0,
        name: '',
        picture_path: '',
        file_seq: 0,
        phone: '',
        msg_type: '',
        school_name: '',
        password: '',
        password_new: '',
        password_confirm: ''
      },
      fileHeaders: {
        Authorization: '',
        Seq: 0,
        Table: 'USER'
      },
      rules: {
        name: [
          { required: true, message: '사용자 이름을 입력하십시오.', trigger: 'blur' },
          { min: 2, max: 5, message: '최소 2자 이상 최대 5자까지 입력하십시오.' }
        ],
        phone: [
          { required: true, message: '전화번호를 입력하십시오.', trigger: 'blur' },
          { type: 'string', pattern: /^[0-9]/, message: '숫자만 가능합니다.' },
          { type: 'string', pattern: /^01([0|1|6|7|8|9]?)-?(\d{3,4})-?(\d{4})$/, message: '전화번호 형식에 맞지 않습니다.' }
        ],
        msg_type: [
          { required: true, message: '알림톡 수신 설정을 선택하십시오.' }
        ],
        password: [
          { required: false, message: '현재 비밀번호를 입력하십시오.' },
          { min: 8, max: 16, message: '최소 8자 이상 16자 이내로 입력하십시오.' },
          { validator: validatePass1 }
        ],
        password_new: [
          { required: false, message: '새로운 비밀번호를 입력하십시오.' },
          { min: 8, max: 16, message: '최소 8자 이상 16자 이내로 입력하십시오.' },
          { validator: validatePass2 }
        ],
        password_confirm: [
          { required: false, message: '새로운 비밀번호 확인을 입력하십시오.' },
          { min: 8, max: 16, message: '최소 8자 이상 16자 이내로 입력하십시오.' },
          { validator: validatePass3 }
        ]
      },
      isPhoneModify: false,
      isDisabled: true,
      phoneDisabled: false,
      timer: 3 * 60 * 1000,
      pincode: '',
      otp: {
        user_otp_seq: 0,
        cmid: '',
        confirm: false,
        phone: ''
      }
    }
  },
  created () {
    this.loadUserInfo()
  },
  mounted () {
    this.fileHeaders.Authorization = this.$store.getters.access_token
  },
  methods: {
    loadUserInfo () {
      common.axios.get('/user/load/' + this.$store.getters.user_seq)
        .then(response => {
          const result = response.data
          Object.keys(this.userInfo).forEach(key => {
            this.userInfo[key] = this.isEmpty(result[key]) ? '' : result[key]
            this.frm.name = result.name
            this.frm.user_info_seq = result.user_info_seq
            this.frm.picture_path = result.picture_path
            this.frm.msg_type = result.msg_type
            this.frm.phone = result.phone
            this.autoHypenPhone('phone')
          })
        })
    },
    handleAvatarSuccess (res, file) {
      if (res.status === 1 && res.file_seq !== undefined) {
        this.frm.file_seq = res.file_seq
        this.frm.picture_path = URL.createObjectURL(file.raw)
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('사진은 jpg, png 파일만 업로드 가능합니다.')
      }
      if (!isLt2M) {
        this.$message.error('최대 2MB까지 가능합니다.')
      }
      return isJPG && isLt2M
    },
    deleteUserAvatar () {
      if (!this.frm.picture_path) {
        this.$message.warning('삭제할 프로필 사진이 없습니다.')
        return false
      }
      this.$confirm('프로필 사진을 삭제하시겠습니까?', '', {
      }).then(() => {
        common.axios.delete('/user/profile', {data: this.frm})
          .then(response => {
            if (response.data.status === 1) {
              this.$message('삭제되었습니다.')
              this.frm.file_seq = 0
              this.frm.picture_path = ''
              this.userInfo.picture_path = ''
              this.$store.dispatch('USER_INFO_UPDATE')
                .then(() => {
                  this.$parent.$parent.updateUserProfile()
                })
            }
          })
      }).catch(() => {})
    },
    submitForm: function () {
      this.$refs.frm.validate(valid => {
        if (valid) {
          if (this.isPhoneModify) {
            if (this.userInfo.phone !== this.getOnlyNumber(this.frm.phone)) {
              this.$message.error('전화번호 인증 후 수정이 가능합니다.')
              return
            }
          }
          this.$confirm('변경 사항을 저장하시겠습니까?', '', {
          }).then(() => {
            this.frm.phone = this.getOnlyNumber(this.frm.phone)
            common.axios.put('/user/profile', this.frm)
              .then(response => {
                if (response.data.status === 1) {
                  this.$message('수정하였습니다.')
                  this.$store.dispatch('USER_INFO_UPDATE')
                    .then(() => {
                      this.$parent.$parent.updateUserProfile()
                    })
                  this.$nextTick(() => {
                    setTimeout(() => {
                      this.$router.push({name: 'MAIN_S'})
                    }, 1000)
                  })
                } else {
                  this.$message.error(response.data.message)
                }
              })
          }).catch(() => {})
        } else {
          this.$message.error('수정 내용을 확인하십시오.')
          return false
        }
      })
    },
    cancleForm () {
      this.$router.push({name: 'MAIN_S'})
    },
    selectFile () {
      this.$refs.uploader.$children[0].$refs.input.click()
    },
    autoHypenPhone (elem) {
      const value = this.getOnlyNumber(this.frm[elem])
      let tmp = ''
      if (value.length < 4) {
        tmp = value
      } else if (value.length < 7) {
        tmp += value.substr(0, 3)
        tmp += '-'
        tmp += value.substr(3)
      } else if (value.length < 11) {
        tmp += value.substr(0, 3)
        tmp += '-'
        tmp += value.substr(3, 3)
        tmp += '-'
        tmp += value.substr(6)
      } else {
        tmp += value.substr(0, 3)
        tmp += '-'
        tmp += value.substr(3, 4)
        tmp += '-'
        tmp += value.substr(7)
      }
      this.frm[elem] = tmp
    },
    requestCallback () {
      if (!this.frm.phone) {
        this.$alert('전화번호를 입력하십시오.')
        return
      }
      this.otp = {user_otp_seq: 0, cmid: '', confirm: false, phone: ''}
      common.axios.post('/kakao/otp/request', {phone: this.getOnlyNumber(this.frm.phone)})
        .then(response => {
          const result = response.data
          // console.log('result : ', result)
          if (result.result_code === '200') {
            this.$alert('인증번호가 발송되었습니다. 3분이내에 인증번호를 입력하십시오.')
            this.otp.user_otp_seq = result.user_otp_seq
            this.otp.cmid = result.cmid
            this.isDisabled = false
            this.$nextTick(() => {
              const countdown = this.$refs.countdown
              // 카운트를 하고 있으면 정지한다.
              if (countdown.counting) {
                countdown.stop()
              }
              // 카운트 초기화
              countdown.count = this.timer
              // 카운팅 시작
              countdown.start()
            })
          } else {
            this.$alert('인증번호 발송 오류입니다. 관리자에게 문의하십시오.')
          }
        })
    },
    confirmCallback () {
      if (!this.pincode) {
        this.$alert('인증번호를 입력하십시오.')
        return
      }
      const param = Object.assign({otp_no: this.pincode}, this.otp)
      common.axios.post('/kakao/otp/confirm', param)
        .then(response => {
          const result = response.data
          // console.log('result : ', result)
          if (result.result_code === '200') {
            this.$alert('인증되었습니다.')
            this.initPincode(true)
            this.otp.confirm = true
            this.otp.phone = result.phone
          } else if (result.result_code === '600') {
            this.$alert('일치하지 않는 인증번호입니다.')
          } else if (result.result_code === '700') {
            this.$alert('인증시간이 만료되었습니다. 인증번호를 다시 요청하십시오.')
            this.initPincode(false)
          } else {
            this.$alert(result.result_code)
          }
        })
    },
    initPincode (isSuccess) {
      this.isDisabled = true
      this.timer = 0
      this.pincode = ''
      this.phoneDisabled = isSuccess
      this.isPhoneModify = false
    }
  }
}
</script>

<style scoped>
  .el-input-phone {
    width: calc(100% - 110px);
  }
  .el-input-pincode {
    width: 206px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/S990101.vue